import React, { useState } from 'react';
import { getIntegrationStatus } from 'helpers/orders';
import ResolveSyncPopup from './ResolveSyncPopup';
import IntegrationInfo from './IntegrationInfo';


const OrderIntegrations = ({ order }) => {
  const { emr_sync_error, nextech_id, modmed_id } = order.extension_attributes;
  const [openResolveWindow, setOpenResolveWindow] = useState(false);
  const [resolveIntegration, setResolveIntegration] = useState('nextech');

  const nextechStatus = getIntegrationStatus(order, 'nextech');
  const modmedStatus = getIntegrationStatus(order, 'modmed');

  const openResolve = (integration) => {
    setResolveIntegration(integration);
    setOpenResolveWindow(true);
  };

  return (
    <div className="flex">
      {nextechStatus !== 'disabled' && (
        <IntegrationInfo
          title="Nextech info"
          status={nextechStatus}
          idLabel="Nextech Order ID"
          orderId={nextech_id}
          errorType={emr_sync_error}
          orderEmail={order.customer_email}
          onResolve={nextechStatus === 'error' ? () => openResolve('nextech') : null}
        />
      )}
      {modmedStatus !== 'disabled' && (
        <IntegrationInfo
          title="Modmed info"
          status={modmedStatus}
          idLabel="Modmed Order ID"
          orderId={modmed_id}
          errorType={emr_sync_error}
          orderEmail={order.customer_email}
          onResolve={modmedStatus === 'error' ? () => openResolve('modmed') : null}
        />
      )}
      <ResolveSyncPopup order={order} openResolveWindow={openResolveWindow} setOpenResolveWindow={setOpenResolveWindow} integration={resolveIntegration} />
    </div>
  );
};

export default OrderIntegrations;
